import React from 'react';
import './App.css';

// import Logo from './assets/logo/logo-blue.png';
// import HomePage from './pages/HomePage/HomePage';
//import Portal from './pages/Portal/Portal';
import {  BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Error404 from '@views/Error404/Error404';
import Main from '@views/Main/Main';
import Portal from '@views/Portal/Portal';


function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/portal" element={<Portal />} />
        <Route path="/*" element={<Main />} />
        <Route path="*" element={<Error404 link="/"/>} />
      </Routes>
    </Router>
  );
}

export default App;